import paymentMethods from "./paymentMethods";
import storeSubscriptions from "./storeSubscriptions";
import registrationPlans from "./registrationPlans";
import subscriptionBillings from "./subscriptionBillings"


export default {
    namespaced: true,
    modules: {
        paymentMethods,
        storeSubscriptions,
        registrationPlans,
        subscriptionBillings
    }
};
